export default function Collections() {
  return (
    <div>
      <h1>Collections</h1>
    </div>
  );
}
